import { get } from "./api";

export const URLS = {
    search: () => `/api/fichiers/search`,
    getSelection: () => `/api/fichiers/get/selection`,
    getFichier: (id) => `/api/fichiers/get/${id}`
}

export async function search (params) {
    return await get(URLS.search(), params)
}

export async function getSelection (params) {
    return await get(URLS.getSelection(), params)
}

export async function getFichier (id) {
    return await get(URLS.getFichier(id))
}
